import { useQuery, type WatchQueryFetchPolicy } from "@apollo/client";

import { ClientPaymentMethodDocument } from "../../__generated__/graphql";
import { useClientId } from "../../shared";

type UseClientPaymentMethodOptions = {
  clientId?: string;
  skip?: boolean;
  fetchPolicy?: WatchQueryFetchPolicy;
};

export function useClientPaymentMethod({
  clientId: explicitClientId,
  skip,
  fetchPolicy = "cache-only",
}: UseClientPaymentMethodOptions = {}) {
  const currentClientId = useClientId();
  const clientId = explicitClientId ?? currentClientId;
  const { data, refetch } = useQuery(ClientPaymentMethodDocument, {
    skip: skip || !clientId,
    fetchPolicy,
    variables: { id: clientId },
  });

  const card = data?.client.paymentMethod ?? null;
  const hasCard = Boolean(card);
  const autoPayEnabled = Boolean(data?.client.preferences?.autoPay);

  return {
    paymentMethodId: card?.id ?? null,
    card,
    hasCard,
    autoPayEnabled,
    loaded: Boolean(data),
    refetch,
  };
}
